import { ISupplementARepository } from '../../application/ports/outbound/ISupplementARepository';
import { HttpClient } from '@/shared/infra/http/HttpClient';
import {
  mapInterpreterFormToDto,
  mapInterpreterResponseDtoToEntity,
} from './mappers/interpreterMapper';
import { SupplementAInterpreterForm } from '../../features/supplement-a/application/validators/supplement_a.schema';
import { InterpreterResponseDto } from './dto/res/interpreterResponseDto';

export class ApiInterpreterRepository implements ISupplementARepository {
  constructor(private readonly httpClient: HttpClient) {}

  async addInterpreter(
    data: SupplementAInterpreterForm[],
    i9FormId: string
  ): Promise<SupplementAInterpreterForm[]> {
    const filtered = data.filter((i: any) => !i.supplementAId);
    if (filtered.length === 0) return [];
    const newlyAdded = mapInterpreterFormToDto(filtered, i9FormId);

    const response = await this.httpClient.post<InterpreterResponseDto[]>(
      '/supplement-a',
      newlyAdded
    );

    const mappedInterpreters = response.data.map(mapInterpreterResponseDtoToEntity);
    return mappedInterpreters;
  }

  async updateInterpreter(
    data: SupplementAInterpreterForm[],
    i9FormId: string
  ): Promise<SupplementAInterpreterForm[]> {
    const filtered = data.filter((i: any) => i.supplementAId);
    if (filtered.length === 0) return [];
    const updated = mapInterpreterFormToDto(filtered, i9FormId);
    const response = await this.httpClient.put<InterpreterResponseDto[]>('/supplement-a', updated);
    const mappedInterpreters = response.data.map(mapInterpreterResponseDtoToEntity);
    return mappedInterpreters;
  }

  async deleteInterpreter(supplementAId: string): Promise<boolean> {
    const response = await this.httpClient.delete(
      `/supplement-a/${supplementAId}`
    );
    return response.data;
  }
}

export default ApiInterpreterRepository;
